import { createTransform } from 'redux-persist';
import { BaseCryptoUtils } from '@ibk/shared-utils';
export class ReduxCryptoTransform extends BaseCryptoUtils {
    handleTransformError(operation, error, fallbackValue) {
        const errorMessage = `Error ${operation} Redux state`;
        console.error(`${errorMessage}:`, error);
        return fallbackValue;
    }
    serializeAndEncrypt(state) {
        try {
            const serialized = JSON.stringify(state);
            return this.simpleEncrypt(serialized, this.getObfuscatedKey());
        }
        catch (error) {
            return this.handleTransformError('encrypting', error, state);
        }
    }
    decryptAndDeserialize(encryptedState) {
        try {
            if (typeof encryptedState !== 'string') {
                return encryptedState;
            }
            const decrypted = this.simpleDecrypt(encryptedState, this.getObfuscatedKey());
            return JSON.parse(decrypted);
        }
        catch (error) {
            return this.handleTransformError('decrypting', error, encryptedState);
        }
    }
    createTransform(sliceNames) {
        return createTransform((inboundState) => this.serializeAndEncrypt(inboundState), (outboundState) => this.decryptAndDeserialize(outboundState), {
            whitelist: sliceNames,
        });
    }
    clearAllCryptoKeys() {
        this.clearCryptoKeys();
    }
}
export const reduxCryptoTransform = new ReduxCryptoTransform();
export const encryptTransform = reduxCryptoTransform.createTransform([
    'tokens',
    'user',
    'hasAccess',
]);
